import React, { useContext } from 'react';

import { shouldShowAds } from '../../util/ads-utils';
import { AdsSkyScraper } from '../Ads';
import DocumentContext from './DocumentContext';

export const LeftSidebar: React.FC = () => {
    const context = useContext(DocumentContext);
    const showSidebar = context.appState.currentLayout.name === 'wideScreen';
    return showSidebar && shouldShowAds({ context }) ? <AdsSkyScraper /> : null;
};
